import { uniqueId } from 'lodash';
import { action } from 'mobx';

export const makeAreaNode = action((parentId) => {
  const node = {
    id: uniqueId(),
    type: 'area',
    meta: { parentId },
    nodes: null,
    nodeIds: null,
  };

  return node;
});

export const makeElementNode = action((parentId, flex) => {
  const id = uniqueId();
  const areaNode = makeAreaNode(id);
  const node = {
    id,
    type: 'element',
    meta: { flex, parentId },
    nodes: [areaNode],
    nodeIds: [areaNode.id],
  };

  return node;
});

export const makeSplitterNode = action((parentId) => {
  const node = {
    id: uniqueId(),
    type: 'split',
    meta: { parentId },
    nodes: null,
    nodeIds: null,
  };

  return node;
});

export const makeContainerNodes = action((parentId, primaryFlex) => {
  return [
    makeElementNode(parentId, primaryFlex),
    makeSplitterNode(parentId),
    makeElementNode(parentId, 1 - primaryFlex),
  ];
});
